import { render, staticRenderFns } from "./pop-up-compatible.vue?vue&type=template&id=7b219403&scoped=true"
import script from "./pop-up-compatible.vue?vue&type=script&lang=js"
export * from "./pop-up-compatible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b219403",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b219403')) {
      api.createRecord('7b219403', component.options)
    } else {
      api.reload('7b219403', component.options)
    }
    module.hot.accept("./pop-up-compatible.vue?vue&type=template&id=7b219403&scoped=true", function () {
      api.rerender('7b219403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/view/components/TabPrizeView/components/NotVeryCompatible/pop-up-compatible.vue"
export default component.exports